const getInitState = () => {
  return {
    dialog: {
      visible: false,
      appendToBody: false,
      modal: true,
    },
    languageMode: 'create',
  }
}

export default {
  namespaced: true,

  state: getInitState(),

  mutations: {
    openDialog(state, { mode }) {
      state.dialog.visible = true
      if (mode) {
        state.languageMode = mode
      } else {
        state.languageMode = 'create'
      }
    },

    closeDialog(state) {
      state.dialog.visible = false
      Object.assign(state, getInitState())
    },
  },
}
